module.exports = __webpack_public_path__ + "static/media/incomingDocuments.532df620.svg";